<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on">
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="openDialog = true">
                <v-list-tile-content>
                  <v-list-tile-title>IMPORT EXCEL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :loading="printAllButtonLoading"
                color="success"
                v-bind="attrs"
                v-on="on"
                ><v-icon>cloud_download</v-icon>Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile @click="printAllCustomer('printCustomer')">
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="exportAllCustomer()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm2>
              <v-text-field
                name="code"
                label="Customer Code"
                type="text"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-text-field
                name="name"
                label="Customer Name"
                type="text"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-text-field
                name="township"
                label="Township"
                type="text"
                v-model="queryParams.township"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-select
                :items="creditLevelList"
                v-model="queryParams.creditLevelId"
                label="Choose Credit Level"
                item-text="name"
                item-value="id"
                menu-props="auto"
              ></v-select>
            </v-flex>
            <v-flex sm2>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm2>
              <v-select
                :items="regionList"
                label="Region"
                v-model="queryParams.regionId"
                item-text="name"
                @change="changeRegion"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="customerList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            must-sort
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-btn
                  flat
                  icon
                  color="blue lighten-2"
                  @click="onEdit(props.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
              <td>
                <v-icon
                  v-if="props.item.status == 'ACTIVE'"
                  medium
                  color="green"
                  >check_circle</v-icon
                >
                <v-icon v-else medium color="red">cancel</v-icon>
              </td>
              <td>{{ props.item.code }}</td>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.email }}</td>
              <td>{{ props.item.phoneNo }}</td>
              <td>{{ props.item.address }}</td>
              <td>{{ props.item.advancedAmount | decFormat(6) }}</td>
              <td>{{ props.item.creditLevel.name }}</td>
              <td>
                {{
                  props.item.updatedDateInMilliSeconds
                    | format-ms-date-time
                }}
              </td>
              <td>{{ props.item.updatedBy }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!--print all-->
    <div
      id="printCustomer"
      style="border: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 18px; margin: 1px">Customer Report</p>
      </div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 11px;
            border-top: 1px solid black;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="text-align: left">Code</th>
              <th style="text-align: left">Name</th>
              <th style="text-align: left">Email</th>
              <th style="text-align: left">PhoneNo</th>
              <th style="text-align: left">Address</th>
              <th style="text-align: left">Advanced Amount</th>
              <th style="text-align: left">Credit Level</th>
              <th style="text-align: left">Updated Date</th>
              <th style="text-align: left">Updated By</th>
              <th style="text-align: left">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in allCustomerList" :key="index">
              <td style="text-align: left">{{ item.code }}</td>
              <td style="text-align: left">{{ item.name }}</td>
              <td style="text-align: left">{{ item.email }}</td>
              <td style="text-align: left">{{ item.phoneNo }}</td>
              <td style="text-align: left">{{ item.address }}</td>
              <td style="text-align: left">
                {{ item.advancedAmount | decFormat(6) }}
              </td>
              <td style="text-align: left">{{ item.creditLevel.name }}</td>
              <td style="text-align: left">
                {{
                  item.updatedDateInMilliSeconds | format-ms-date-time
                }}
              </td>
              <td style="text-align: left">{{ item.updatedBy }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- dialog -->
    <customerExcel
      :isOpen="openDialog"
      v-on:change="dialogClose()"
    ></customerExcel>
  </v-container>
</template>

<script>
import { customerService } from "../../services/customer-service";
import { creditLevelService } from "../../services/credit-level-service";
import customerExcel from "../../components/customer/CustomerExcel";
import { commonService } from "../../services/common-service";
import { regionService } from "../../services/region-service";

export default {
  name: "CustomerList",

  components: { customerExcel },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "General",
        disabled: true,
      },
      {
        text: "Customer",
        disabled: true,
      },
    ],
    statusList: [
      { label: "--- ALL ---", value: "" },
      { label: "Active", value: "ACTIVE" },
      { label: "Inactive", value: "INACTIVE" },
    ],
    headers: [
      { text: "Action", value: "name", sortable: false },
      { text: "Status", value: "status", sortable: false },
      { text: "Code", align: "left", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Email", value: "email" },
      { text: "PhoneNo", value: "phoneNo" },
      { text: "Address", value: "address" },
      { text: "Advanced Amount", value: "advancedAmount", sortable: false },
      { text: "Credit Level", value: "creditLevel", sortable: false },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    printAllButtonLoading: false,
    customerList: [],
    allCustomerList: [],
    decimalFormat: "",
    totalRows: 0,
    openDialog: false,
    queryParams: {
      code: "",
      name: "",
      township: "",
      creditLevelId: "",
      status: "",
      regionId: "",
      isNoRegion: "",
    },
    creditLevelList: [],
    regionList: [],
  }),
  watch: {
    pagination: {
      handler() {
        this.getCustomerList();
      },
      deep: true,
    },
  },
  created() {
    //for deep linking
    this.queryParams.status = "ACTIVE";
    if (this.$route.query.code) {
      this.queryParams.code = this.$route.query.code;
    }
    if (this.$route.query.name) {
      this.queryParams.name = this.$route.query.name;
    }
    if (this.$route.query.township) {
      this.queryParams.township = this.$route.query.township;
    }
    if (this.$route.query.creditLevelId) {
      this.queryParams.creditLevelId = this.$route.query.creditLevelId;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getCreditLevels();
    this.getRegionList();
    this.decimalFormat = commonService.formatdecimal();
    this.changeRegion();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "customers", query: this.queryParams });
      this.getCustomerList();
    },
    getCustomerList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      customerService
        .getCustomers(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.customerList = res.data.customerList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    exportAllCustomer() {
      this.printAllButtonLoading = true;
      customerService
        .getCustomerExcelExport(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.printAllButtonLoading = false;
        });
    },
    printAllCustomer(divName) {
      this.printAllButtonLoading = true;
      customerService
        .getAllCustomer(this.queryParams)
        .then((res) => {
          if (res.data) {
            this.allCustomerList = res.data.customerList;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
        });
      this.printAllButtonLoading = false;
    },
    getCreditLevels() {
      creditLevelService
        .getCreditLevels()
        .then((res) => {
          if (res.data) {
            this.creditLevelList = res.data.creditLevelList;
            let findAll = {
              id: "",
              name: "----All----",
            };
            this.creditLevelList.splice(
              0,
              0,
              JSON.parse(JSON.stringify(findAll))
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getRegionList() {
      regionService
        .getRegionsByStatus("ACTIVE")
        .then((res) => {
          this.regionList = res.data;
          let noregion = {
            id: "",
            name: "----No Region----",
          };
          this.regionList.splice(0, 0, JSON.parse(JSON.stringify(noregion)));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeRegion() {
      if (this.queryParams.regionId) {
        this.queryParams.isNoRegion = false;
      } else {
        this.queryParams.isNoRegion = true;
      }
    },
    onRegister() {
      this.$router.push("/customer/new");
    },
    dialogClose() {
      this.openDialog = false;
      this.getCustomerList();
    },
    onEdit(customer) {
      // go to details page
      this.$router.push("/customer/" + customer.id);
    },
  },
};
</script>
